
import { defineComponent } from "vue";
import Card2 from "@/components/cards/Card2.vue";

export default defineComponent({
  name: "campaigns",
  components: {
    Card2,
  },
});
